var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_4030_109044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.03125 4.99902H4V15.999H1.03125V4.99902ZM10.0938 4.99902C9.54167 4.99902 9.11198 5.10059 8.80469 5.30371C8.4974 5.50684 8.22917 5.69694 8 5.87402V4.99902H5.01562V15.999H8V9.07715C8 9.07715 8.04948 8.84798 8.14844 8.38965C8.2474 7.93132 8.71354 7.70215 9.54688 7.70215C10.0469 7.70215 10.4141 7.82975 10.6484 8.08496C10.8828 8.34017 11 8.6709 11 9.07715V15.999H14.1406V9.1709C14.1406 8.2334 13.9792 7.48861 13.6562 6.93652C13.3333 6.38444 12.9505 5.96517 12.5078 5.67871C12.0651 5.39225 11.6146 5.20736 11.1562 5.12402C10.6979 5.04069 10.3438 4.99902 10.0938 4.99902ZM1 2.49902C1 2.91569 1.14583 3.26986 1.4375 3.56152C1.72917 3.85319 2.08333 3.99902 2.5 3.99902C2.91667 3.99902 3.27083 3.85319 3.5625 3.56152C3.85417 3.26986 4 2.91569 4 2.49902C4 2.08236 3.85417 1.72819 3.5625 1.43652C3.27083 1.14486 2.91667 0.999023 2.5 0.999023C2.08333 0.999023 1.72917 1.14486 1.4375 1.43652C1.14583 1.72819 1 2.08236 1 2.49902Z",
    fill: "#394050"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4030_109044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 15.999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.5f1e982897fff8d0ac9340beb0fa1ef2.svg";
export { ForwardRef as ReactComponent };